const SuccessMessage = ({ children }) => (
  <div className="mt-4 text-sm text-green-600">{children}</div>
);

export default SuccessMessage;
